module.exports = __webpack_public_path__ + "img/Version2_DATAFuer.9b5a7900.png";